<template>
  <CContainer  class="d-flex  min-vh-100" style="place-content: center">
    <CRow >
      <CCol >
        <CCard class="p-2" style="min-width: 330px">
          <CCardBody class="">
            <div>
              <CRow class="mb-2" >
                <CCol col="3">
                  <CIcon name="cil-arrow-left"  v-if="level>1" @click="level=level-1"/>

                </CCol>
                <CCol col="6">
                  <CProgress :max="3" :min="1"  :value="level" class="progress-xs" size="sm" color="success"/>

                </CCol>
                <CCol col="3"></CCol>

              </CRow>
              <div class="text-center">
                <img  width="80px" height="auto" src="/img/panel_icon.png"/>

              </div>

              <h1 class="text-center">Register</h1>
              <div v-if="level==1" class="mt-4">
<div>
  {{ $t('please_enter_email') }}
</div>
                <CInput
                    :placeholder="$t('email')"
                    autocomplete="email"
                    v-model="email"
                />
              </div>

              <div v-if="level==2">
                <div class="text-center">{{ $t('please_enter_business_info') }}</div>
                <CInput
                    :label="$t('full_name')"
                    :placeholder="$t('full_name')"
                    autocomplete="username"
                    v-model="name"
                />
                {{country}}

                <CountrySelect v-model="country"/>
                <CInput
                    :label="$t('mobile_no')"
                    :placeholder="$t('mobile_no')"
                    autocomplete="number"
                    v-model="phone"

                />

                <CInput
                    :label="$t('password')"
                    :placeholder="$t('password')"
                    type="password"
                    v-model="password"
                    autocomplete="new-password"
                />
                <CInput
                    :label="$t('retype_password')"
                    :placeholder="$t('retype_password')"
                    type="password"
                    autocomplete="new-password"
                    v-model="repassword"
                    class="mb-4"
                />

                <CInput
                    :label="$t('business_name')"
                    :placeholder="$t('business_name')"
                    v-model="market_name"
                    class="mb-4"
                />
                <CSelect
                    :value.sync="selected_plan"
                    :options="plans"
                    class="mb-4"
                />

                <CInput
                    :label="$t('max_staff')"
                    :placeholder="$t('max_staff')"
                    v-model="max_staff"
                    :disabled="selected_plan==1"
                    class="mb-4"
                />

              </div>
              <div v-if="level==3">
                {{ $t('enter_sent_code_to_email') }}
                <div class="text-center">{{email}}</div>
                <CInput
                    placeholder=""
                    v-model="code"
                />
                {{accept_rules}}

                <div class="d-flex">
                  <CInputCheckbox :checked.sync="accept_rules"/>
                  <span>I agree to the </span>
                  <a class="mx-1" href="https://bookmeto.com/terms" target="_blank">
                    Terms
                  </a>
                  <span class="mx-1"> & </span>

                  <a  href="https://bookmeto.com/privacy" target="_blank">
                    Privacy Policy
                  </a>

                </div>

              </div>
            </div>
          </CCardBody>
          <CCardFooter class="p-4">
            <CButton v-if="level==1" color="primary" v-on:click="register_check_email()" class="px-4">
              {{ $t('check_email') }}
            </CButton>

            <CButton v-if="level==2" color="primary" v-on:click="check_register_data()" class="px-4">
              {{ $t('submit_information') }}
            </CButton>
            <CButton  v-if="level==3" color="primary" v-on:click="register_market()" class="px-4">
              {{ $t('register') }}
            </CButton>
            <CRow class="" v-if="level==1">

              <label @click="$router.push({path:'/dashboard/login'})">{{ $t('have_account_login') }}</label>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>

</template>

<script>
import axios from "axios";
import Modals from "../includes/Modals";
import Vue from "vue";
import CountrySelect from "../includes/CountrySelect.vue";

export default {
  name: 'Register',
  data() {
    return {
      accept_rules:false,
      level:1,
      email:'',
      name:'',
      phone:'',
      market_name:'',
      password:'',
      repassword:'',
      selected_plan:0,
      code:'',
      country:'',
      max_staff:'1',
      plans:[
        {label:'Plan',value:0},
        {label:'Independent / 1 Staff',value:1},
        {label:'Team / 5 Staff Members',value:2},
        {label:'Enterprise',value:3},
      ],
    }
  },
  components: {
    CountrySelect,
    Modals
  },
  watch:{
    'selected_plan':function (){
      if(this.selected_plan==1){
        this.max_staff='1'
      }
    }

  },
  mounted() {

  },
  methods: {
check_register_data(){

  if(this.name==''){
    Vue.$toast.open({
      message: this.$t('enter_name'),
      type: 'error',
    });
    return false
  }
  if(this.phone==''){
    Vue.$toast.open({
      message: this.$t('enter_phone_no'),
      type: 'error',
    });
    return false
  }
  if(this.market_name==''){
    Vue.$toast.open({
      message: this.$t('enter_business_name'),
      type: 'error',
    });
    return false
  }
  if(this.max_staff==''){
    Vue.$toast.open({
      message: this.$t('insert_max_staff'),
      type: 'error',
    });
    return false
  }
  if(this.password==''){
    Vue.$toast.open({
      message: 'لطفا رمز عبور را وارد کنید',
      type: 'error',
    });
    return false
  }
  if(this.password!=this.repassword){
    Vue.$toast.open({
      message: this.$t('password_repassword_not_equal'),
      type: 'error',
      // all of other options may go here
    });
    return false
  }
  if(this.password.length<5){
    Vue.$toast.open({
      message: this.$t('password_must_5_char'),
      type: 'error',
      // all of other options may go here
    });
    return false
  }
  if(this.selected_plan==0){
    Vue.$toast.open({
      message: this.$t('select_plan'),
      type: 'error',
      // all of other options may go here
    });
    return false
  }

  this.level=3
},
    goRegister() {
      this.$router.push({path: '/register'});
    },
    register_check_email() {


      let self = this;
      const formData = new FormData()
      let url = "/api/admin/user/check_email";
      // delete axios.defaults.headers.post['Authorization'];
      axios.defaults.headers.post['Authorization'] = "";


      formData.append('email', this.email)

      axios.post(url, formData).then((res) => {

        if(res.data.error==1){
          Vue.$toast.open({
            message: res.data.msg,
            type: 'error',
            // all of other options may go here
          });

        }else{
          self.level=2
        }



      })

          .catch(function (error) {

            console.log(error);
          });

    },
    register_market() {

      if(this.accept_rules==false){
        Vue.$toast.open({
          message: "Please read and accept terms & privacy policy",
          type: 'error',
          // all of other options may go here
        });
        return false
      }

      let self = this;
      const formData = new FormData()
      let url = "/api/admin/user/register_trial_market";
      // delete axios.defaults.headers.post['Authorization'];
      axios.defaults.headers.post['Authorization'] = "";

      formData.append('email', this.email)
      formData.append('password', this.password)
      formData.append('phone', this.phone)
      formData.append('market_name', this.market_name)
      formData.append('full_name', this.name)
      formData.append('plan', this.selected_plan)
      formData.append('country', this.country.toLowerCase())
      formData.append('max_staff', this.max_staff)
      formData.append('code', this.code)

      axios.post(url, formData).then((res) => {

        if(res.data.error==1){
          Vue.$toast.open({
            message: res.data.msg,
            type: 'error',
            // all of other options may go here
          });

        }else{
          Vue.$toast.open({
            message: res.data.msg,
            type: 'success',
            // all of other options may go here
          });
          localStorage.setItem('languages',JSON.stringify(res.data.languages));
          localStorage.setItem('token',res.data.token);
          localStorage.setItem('site_url',res.data.site);
          localStorage.setItem('user_name',res.data.user_name);
          localStorage.setItem('user_id',res.data.user_id);
          localStorage.setItem('image',res.data.image);
          localStorage.setItem('market_expire',res.data.market.expire_date);
          axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');

          self.$router.push({ path: '/dashboard'});

        }



      })

          .catch(function (error) {

            console.log(error);
          });

    },
    forgot_password() {
      if (this.user == "") {
        this.$refs.modal.show_danger_modal(this.$t("error"), this.$t('insertMobile'));
        return;
      }
      let self = this;
      self.loading = true;
      const formData = new FormData();
      if(this.forgot_password_number.includes("@")){
        formData.append('mobileNo', "");
        formData.append('eMail', this.forgot_password_number);
      }else{
        formData.append('mobileNo', this.forgot_password_number);
        formData.append('eMail', "");
      }
      delete axios.defaults.headers.post["Authorization"];
      axios.post("ForgotPassword", formData, {}).then((res) => {
        self.loading = false;

        // console.log(res.headers.value('token'));
// res.headers.value('token');
        if (res.data.statusCode != 0) {
          this.$refs.modal.show_danger_modal(this.$t("dialogs.error"), res.data.message);
        } else {
          this.$refs.modal.show_api_response_modals(this.$t("dialogs.error"), res);
        }

        // Modals.show_danger_modal('sss',"sdsddd",[]);


      }).catch(function (error) {
        self.loading = false;

      });

    }
  }
}


</script>
